<nb-card class="PageFormat">
  <nb-card-body>
    <nb-tabset>
      <nb-tab i18n-tabTitle="@@PatientInfo" tabTitle="Patient Info">
        <div class="col-sm-12">
          <app-patient-general-info
            [PatientId]="PatientID"
          ></app-patient-general-info>
        </div>
      </nb-tab>
      <nb-tab tabTitle="Weekly CheckIn">
        <div class="col-sm-12">
          <app-patient-progress [patientId]="PatientID"></app-patient-progress>
        </div>
      </nb-tab>
      <nb-tab i18n-tabTitle="@@Goals" tabTitle="Goals">
        <div class="col-sm-12">
          <app-goals-list-view
            [PatientID]="PatientID"
            [AllowEdit]="false"
            [IsView]="false"
          ></app-goals-list-view>
        </div>
      </nb-tab>
    </nb-tabset>
  </nb-card-body>
</nb-card>
